import BlockTypes from '../../../types/BlockTypes';

function isNextBlockACell(nextBlock) {
  return nextBlock && nextBlock.type === BlockTypes.TABLE_CELL;
}

function mergeStartBlockWithNextBlock(editor, startBlock, nextBlock) {
  var nextBlockParent = editor.value.document.getParent(nextBlock.key);
  editor.snapshotSelection();
  return editor.withoutNormalizing(function () {
    if (nextBlockParent) {
      editor.moveNodeByKey(startBlock.key, nextBlockParent.key, nextBlockParent.getPath(nextBlock.key).first());
    }

    editor.mergeNodeByKey(nextBlock.key).setNodeByKey(startBlock.key, {
      type: nextBlock.type,
      data: nextBlock.data
    }).moveTo(startBlock.getLastText().key).moveToEndOfText();
  });
}

export default function onDelete(event, editor, next) {
  if (!editor.isAtEndOfBlock()) {
    return next();
  }

  var nextBlock = editor.value.document.getNextBlock(editor.value.startBlock.key); // If next block is an empty cell, default behavior will be to delete it
  // We don't want this, we want the content of the current line to be put
  // inside next cell

  if (isNextBlockACell(nextBlock)) {
    event.preventDefault();
    return mergeStartBlockWithNextBlock(editor, editor.value.endBlock, nextBlock);
  }

  return next();
}